var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['rph-badge', `rph-badge--${_vm.borderColor}`, { 'rph-badge--long': _vm.count >= 100 }]},[_vm._v("\n  "+_vm._s(_vm.count)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }